import EntityManageView from 'Components/EntityManageView';
import { actions } from 'ducks/readings';
import React from 'react';
import { useSelector } from 'react-redux';
import { metadataFields } from 'utils/forms/utils';
import validators from 'utils/forms/validators';
import { getReadingMetadata } from 'utils/getMetadata.js';

const Component = props => {
    const model = useSelector(state => state.readings.models[state.drawerView.entityId]);
    const submitting = useSelector(state => state.readings.submitting);

    const equipment = useSelector(state => state.equipments.models[model.equipment_id]);
    const metadata = getReadingMetadata(equipment);

    const stateProps = { metadata, model, submitting };

    const actionProps = ({
        create: actions.useCreate(),
        update: actions.useUpdate()
    });

    const formSchema = [
        {
            type: 'text',
            label: 'Name\x2a',
            name: 'name',
            validate: [validators.required]
        },
        ...metadataFields(metadata, model),
        {
            type: 'checkBox',
            label: 'Activate Measurement?',
            name: 'activate_measurement'
        },
        {
            type: 'checkBox',
            label: 'Create Indicator?',
            name: 'create_indicator'
        }
    ];

    return (
        <EntityManageView
            formInitialValues={model}
            formSchema={formSchema}
            label="Edit Reading"
            {...stateProps}
            {...actionProps}
            {...props}
        />
    );
};

export default Component;
